import { useEffect, useRef } from 'react'
import { ChainMeta, TokenMeta } from 'state/tokens'
import { formatCurrency, onlyNumbers } from 'toolbox/format'

export interface InputContainerProps {
  token: TokenMeta
  chain: ChainMeta
  inputVal: string
  setInput: (val: string) => void
  inputDollars: number
  setMax: () => void
  hideMax: boolean
  focusTrigger: number
}

export function InputContainer({
  token,
  chain,
  inputVal,
  setInput,
  inputDollars,
  setMax,
  hideMax,
  focusTrigger
}: InputContainerProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const mounted = useRef(false)

  useEffect(() => {
    if (mounted.current) {
      inputRef.current?.focus()
    } else {
      mounted.current = true
    }
  }, [focusTrigger])

  const hideMaxClass = hideMax ? 'hide' : ''
  const numberOfCharacters = inputVal.length
  let size = ''
  if (numberOfCharacters > 9) {
    size = 'small'
  }
  if (numberOfCharacters > 12) {
    size = 'x-small'
  }

  return (
    <div className="input-container">
      <div className="stacked-global large">
        <img src={token?.logo} alt={token?.name} />
        <img src={chain?.logoURL} className="stacker" alt={chain?.name} />
      </div>
      <div className="center">
        <input
          ref={inputRef}
          className={`form-input ${size}`}
          placeholder="0"
          value={inputVal}
          onChange={(e) => setInput(onlyNumbers(e.target.value))}
        />
        <p className="value">{formatCurrency(inputDollars)}</p>
      </div>
      <button onClick={setMax} disabled={hideMax} className={`sp-btn max ${hideMaxClass}`}>
        Max
      </button>
    </div>
  )
}
